import { render } from "./RecycleResource.vue?vue&type=template&id=69b6fc8e"
import script from "./RecycleResource.vue?vue&type=script&lang=js"
export * from "./RecycleResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__